<template lang="pug">
  div
    v-dialog(
      content-class="dialogRelatorio"
      v-if="dialog === true && reportStatus === 'loaded' && this.duties.length > 0"
      v-model="dialog"
      :persistent="exportingExcel"
      max-width="95%"
      hide-overlay
      transition="dialog-bottom-transition"
    )
      v-card(tile style="display: flex; flex-direction: column; height: 100vh; overflow: hidden;")

        .dialogHeader(style="flex: 0 0 auto; font-size: 16px")
          .dialogHeaderTitle
            span {{ months[month] + ' de ' + year }}
              span(:style="{ opacity: 0.5 }") &nbsp;(horas trabalhadas por dia)

          .dialogHeaderClose
            .dialogCloseButton.mdi.mdi-close(@click="closeRelatorioHorasDialog()")

        .dialogBody.timeReportDialogBody(style="flex: 1 1 auto; overflow-y: auto; padding: 0; font-size: 16px; max-height: none;")

          .dialogBodyContent
            .ml-5.mt-2.d-flex.align-center.flex-wrap
              div
                label.csLabel
                  span Período
                .csFields.csFields--date
                  date-picker(v-model="dateRange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

              .d-flex.align-center.ml-10
                v-switch(
                  v-model="showShiftColors"
                  label="Exibir cores por turno"
                  style="padding-top: 25px"
                )
                .legend-container(v-if="showShiftColors")
                  .legend-item
                    span.legend-color-box.legend-color-box--day
                    span Diurno
                  .legend-item
                    span.legend-color-box.legend-color-box--night
                    span Noturno
                  .legend-item
                    span.legend-color-box.legend-color-box--split
                    span Ambos

              sos-button(@buttonClick="exportExcel" buttonLabel="EXPORTAR PARA EXCEL" color="lightblue" buttonIcon="mdi-microsoft-excel" buttonIconSize="20" :loading="exportingExcel" size="medium").mt-5.ml-auto.mr-5

            .relatorio-tables
              table.rel-table-users(cellspacing="0", cellpadding="0")
                thead
                  tr
                    th.rel-table-users-th-top-cl1
                      span -
                    th.rel-table-users-th-top-cl2
                      span -
                  tr
                    th.rel-table-users-th-bottom-cl1
                      span Usuário
                    th.rel-table-users-th-bottom-cl2
                      span Quantidade
                tbody
                  tr(v-for="(item, index) in tableData", :key="index" :class="{ 'bgTotal': item.name === 'Total' }")
                    td.rel-table-users-cl1
                      span(v-if="item.name !== 'Disponíveis' && item.name !== 'Total'")
                        abbr(:title="item.name") {{ item.name }}
                      span(v-else) {{ item.name }}
                    td(:class="index === 0 ? 'rel-table-users-cl2-first' : 'rel-table-users-cl2'")
                      span(:class="index === 0 ? 'qnt_disponiveis' : 'qnt_usuario'") {{ item.qtd || 0 }}

              .rel-table-calendar
                table(cellspacing="0", cellpadding="0")
                  thead
                    tr
                      th(
                        v-for="(num, index) in [...daysInMonth]",
                        :class="'rel-table-calendar-th-top' + (daysInMonth.length - 1 === index ? ' last' : '')"
                      )
                        span {{ num.day_name }}
                    tr
                      th(
                        v-for="(num, index) in [...daysInMonth]",
                        :class="'rel-table-calendar-th-bottom' + (daysInMonth.length - 1 === index ? ' last' : '')"
                      )
                        span {{ num.day_number }}
                  tbody
                    tr(v-for="(item_table, item_table_index) in tableData" :class="{ 'bgTotal': item_table.name === 'Total' }")
                      td(
                        v-for="(item, item_index) in [...daysInMonth]",
                        :class="{\
                          'highlight': item_table_index === 0 && item_table[item.value] !== undefined,\
                          'last': daysInMonth.length - 1 === item_index,\
                          'split-shift': showShiftColors && item_table.name !== 'Total' && item_table[item.value] && item_table[item.value].hasDayShift && item_table[item.value].hasNightShift,\
                          'day-shift': showShiftColors && item_table.name !== 'Total' && item_table[item.value] && item_table[item.value].hasDayShift && !item_table[item.value].hasNightShift,\
                          'night-shift': showShiftColors && item_table.name !== 'Total' && item_table[item.value] && !item_table[item.value].hasDayShift && item_table[item.value].hasNightShift,\
                          'clickable-cell': item_table.name !== 'Total' && item_table[item.value] && item_table[item.value].dutiesList && item_table[item.value].dutiesList.length > 0\
                        }"
                        @click="openDayDetails(item_table, item.value)"
                      )
                        v-tooltip(top content-class="custom-tooltip" v-if="item_table.name !== 'Total' && typeof item_table[item.value] === 'object' && item_table[item.value].dutiesList && item_table[item.value].dutiesList.length > 0")
                          template(v-slot:activator="{ on, attrs }")
                            span(
                              v-bind="attrs"
                              v-on="on"
                              :class="!!item_table[item.value].highlight === true ? 'highlight_red' : ''"
                            ) {{ item_table[item.value].durationInSeconds > 0 ? item_table[item.value].formattedDurationHourAndMinutes : '&nbsp;' }}

                          div
                            div(v-for="(duty, dIndex) in item_table[item.value].dutiesList" :key="dIndex" class="mb-1")
                              strong Início:
                              span {{ duty.start }}
                              span(v-if="duty.value") |
                              strong Valor:
                              span {{ formatMoney(duty.value) }}
                              div(style="font-size: 10px; opacity: 0.8") Duração: {{ duty.duration }}

                        span(v-else v-html="typeof item_table[item.value] === 'object' && item_table[item.value].durationInSeconds > 0 ? item_table[item.value].formattedDurationHourAndMinutes : '&nbsp;'")

              table.rel-table-totalhoras(cellspacing="0", cellpadding="0")
                thead
                  tr
                    th.rel-table-totalhoras-th-top
                      span -
                  tr
                    th.rel-table-totalhoras-th-bottom
                      span Total
                tbody
                  tr(v-for="(item_table, item_table_index) in tableData" :key="item_table_index" :class="{ 'bgTotal': item_table.name === 'Total' }")
                    td
                      span {{ item_table.total || 0 }}

    v-dialog(v-model="detailsDialog" max-width="500px" scrollable)
      v-card
        v-card-title.headline.grey.lighten-2 Detalhes do Dia

        v-card-text.pt-4(style="max-height: 60vh;")
          div(v-if="selectedDayDuties && selectedDayDuties.length > 0")
            v-list(two-line)
              v-list-item(v-for="(duty, index) in selectedDayDuties" :key="index")
                v-list-item-content
                  v-list-item-title.font-weight-bold {{ duty.scale || 'Sem escala definida' }}
                  v-list-item-subtitle Início: {{ duty.start }} - Duração: {{ duty.duration }}
                  v-list-item-subtitle Valor: {{ formatMoney(duty.value) }}
                v-list-item-action
                  v-chip(small :color="duty.isNight ? '#42426E' : '#ffc609'" :text-color="duty.isNight ? 'white' : 'black'") {{ duty.isNight ? 'Noturno' : 'Diurno' }}
          div(v-else)
            p Nenhum detalhe disponível para este dia.

        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="detailsDialog = false") Fechar

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")
    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")
</template>
<script>
  import { mapState } from 'vuex'
  import dateTimeLanguage from '@/constants/dateTimeLanguage'
  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'
  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { parseDate, formatDate, isValidDate, timestrToSec, formatSecondsToTime, formatDuration, formatDurationForTable } from '@/mixins/utils'
  import { valueToTime } from '@/functions'
  import lang from '@/locales/pt_BR.json'
  import SosButton from '@/components/SosButton'
  import SubscriptionModal from '@/modals/SubscriptionModal'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import { getGroupByID, getUserByID } from '@/services/firebase'
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import moment from 'moment'
  import 'moment/locale/pt-br'

  export default {
    name: 'ExportScaleHoursModal',
    components: {
      SubscriptionModal,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'date-picker': DatePicker,
    },
    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],
    data () {
      return {
        showShiftColors: true,
        detailsDialog: false,
        selectedDayDuties: [],

        exportingExcel: false,
        reportStatus: 'loading',
        loading: false,
        group: null,
        users: [],
        duties: [],
        dateRange: null,
        nameMaxLength: 12,
        itemsPerPage: -1,
        tableData: [],
        tabelaDisponiveis: [],
        tabelaUsuarios: [],
        tabelaTotais: [],
        windowHeight: window.innerHeight,
        page: 1,
        pagination: {
          pageSize: 7,
          currentPage: 1,
          pageTotalItens: 0,
          totalPages: 0,
          pageStart: 0,
          pageStop: 3,
        },
        options: {
          align: 'center',
          sortable: false,
        },
        months: lang.months,
        weekDays: lang.weekDays,
        dialog: false,
        lang: dateTimeLanguage,
      }
    },
    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
      }),
      headers () {
        const { $vuetify, daysInMonth, options } = this
        daysInMonth.map((item) => {
          item.text = item.text
            .replace(/(?:\r\n|\r|\n)/g, '<br>')
            .replace(/(?:\(|\))/g, '')
        })
        return $vuetify.breakpoint.mdAndUp
          ? daysInMonth
          : [
            { text: 'Usuário', value: 'name', ...options, },
            { text: 'QTD', value: 'qtd', ...options, },
            ...daysInMonth,
            { text: 'Total', value: 'total', ...options, },
          ]
      },
      daysInMonth () {
        const days = []
        for (let i = 1; i <= this.lastDayOfMonth; i++) {
          const weekDay = new Date(this.year, this.month, i).getDay()
          const weekDayName = this.weekDays[weekDay].abbr
          days.push({
            day_name: weekDayName,
            day_number: i.toString(),
            text: `${weekDayName}<br>${i.toString()}`,
            value: i.toString(),
            align: 'center',
            sortable: false,
          })
        }
        return days
      },
      lastDayOfMonth () {
        const { year, month } = this
        return new Date(year, month + 1, 0).getDate()
      },
    },
    mounted () {
      moment.locale('pt-BR')
    },
    methods: {
      formatMoney(value) {
        if (!value) return 'R$ 0,00'
        return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },
      openDayDetails(userRow, dayValue) {
        if (userRow.name === 'Total' || !userRow[dayValue] || !userRow[dayValue].dutiesList) return

        this.selectedDayDuties = userRow[dayValue].dutiesList
        if (this.selectedDayDuties.length > 0) {
          this.detailsDialog = true
        }
      },
      disableDatesCondition (date, currentValue) {
        return date < new Date(2016, 0, 1)
      },
      showPlanMessage () {
        const planName = this.userSession.planName.name
        const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo gerar o relatório de horas. Preciso de ajuda." target="_blank">suporte</a>`
        const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`
        if (this.userSession.planOrigin === 'CUSTOM') {
          this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas o relatório de horas não está liberado.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'COUPON') {
          this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas o relatório de horas não está liberado.</p>${textSupport}`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
          this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para gerar o relatório de horas, assine o Plano Silver ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
        } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
          this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e o relatório de horas não está liberado.</p>${textSupport}`)
        } else {
          if (!!this.userSession.vindi === true) {
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e o relatório de horas não está liberado.</p>${textSupport}`)
          } else {
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e o relatório de horas não está liberado.</p>${textSupport}`)
          }
        }
      },
      open (p) {
        if (this.exportingExcel || this.loading) return false
        if (freeVersion === false && this.userSession.userCapabilities.relatorioHoras !== true) {
          this.showPlanMessage()
          return false
        }
        this.year = p.year
        this.month = p.month
        this.duties = p.shifts
        var firstDay = new Date(p.year, p.month, 1)
        var lastDay = new Date(p.year, p.month + 1, 0)
        this.dateRange = [formatDate(firstDay), formatDate(lastDay)]
        this.dialog = true
        this.loadData()
      },
      closeRelatorioHorasDialog () {
        if (this.exportingExcel) return false
        this.dialog = false
        this.reportStatus = 'loading'
        this.group = null
        this.users = []
        this.duties = []
        this.tableData = []
        this.tabelaDisponiveis = []
        this.tabelaUsuarios = []
        this.tabelaTotais = []
        this.page = 1
        this.pagination = {
          pageSize: 7,
          currentPage: 1,
          pageTotalItens: 0,
          totalPages: 0,
          pageStart: 0,
          pageStop: 3,
        }
      },
      async outerExport (p) {
        if (this.exportingExcel || this.loading) return false
        if (freeVersion === false && this.userSession.userCapabilities.relatorioHoras !== true) {
          this.showPlanMessage()
          return false
        }
        this.year = p.year
        this.month = p.month
        var firstDay = new Date(p.year, p.month, 1)
        var lastDay = new Date(p.year, p.month + 1, 0)
        this.dateRange = [formatDate(firstDay), formatDate(lastDay)]
        this.$emit('setButtonState', true)
        this.exportingExcel = true
        try {
          const checkEndpoint = this.$route.params.scaleID ? `checktimereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `checkgrouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`
          const generateUrl = this.$route.params.scaleID ? `timereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}/${this.showShiftColors}` : `grouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/`

          const response = await apiCheckReportStatus(checkEndpoint)
          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        } catch (error) {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }
        this.exportingExcel = false
        this.$emit('setButtonState', false)
      },
      async exportExcel () {
        if (this.exportingExcel) return false
        const isItValid = Array.isArray(this.dateRange) && this.dateRange.length === 2 && isValidDate(this.dateRange[0]) && isValidDate(this.dateRange[1])
        if (!isItValid) return this.showMessage('Atenção!', 'Selecione o período do relatório de horas')
        const firstDateObj = parseDate(this.dateRange[0])
        const lastDateObject = parseDate(this.dateRange[1])
        const differenceInDays = Math.floor((lastDateObject - firstDateObj) / (1000 * 60 * 60 * 24))
        if (differenceInDays > 62) return this.showMessage('Atenção!', 'Você pode selecionar até dois meses')
        this.exportingExcel = true
        try {
          const checkEndpoint = this.$route.params.scaleID ? `checktimereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}` : `checkgrouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}`
          const generateUrl = this.$route.params.scaleID ? `timereport/${this.$route.params.groupID}/${this.$route.params.scaleID}/${this.dateRange[0]}/${this.dateRange[1]}/${this.showShiftColors}` : `grouptimereport/${this.$route.params.groupID}/${this.dateRange[0]}/${this.dateRange[1]}/`

          const response = await apiCheckReportStatus(checkEndpoint)
          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        } catch (error) {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }
        this.exportingExcel = false
      },
      checkDutyByYearMonth (duty) {
        const tz = duty.dutyStartDateTZ || ''
        const date = tz === '+0000' ? moment.utc(duty.data_inicio) : moment(duty.data_inicio)
        const dutyMonth = parseInt(date.format('M'))
        const dutyYear = parseInt(date.format('YYYY'))
        return dutyMonth === (this.month + 1) && dutyYear === this.year
      },
      userDutyFilter (duty, user) {
        return this.checkDutyByYearMonth(duty) && duty.uid_pegou === user.uid
      },
      availableDutyFilter (duty) {
        return (
          this.checkDutyByYearMonth(duty) &&
          duty.status !== 'cancelado' &&
          duty.status !== 'fechado' &&
          duty.uid_pegou === 0
        )
      },
      fixedName (string) {
        const { nameMaxLength } = this
        return string.length > nameMaxLength ? `${string.substr(0, nameMaxLength)}...` : string
      },
      async loadData () {
        const { groupID } = this.$route.params
        if (!groupID) return false
        this.$emit('setButtonState', true)
        this.loading = true
        this.users = []
        const group = await getGroupByID(groupID)
        const usersKeys = !!group && !!group.users ? Object.keys(group.users) : []
        this.group = group
        if (usersKeys.length === 0) {
          this.$emit('setButtonState', false)
          this.loading = false
          return false
        }
        const users = (await Promise.all(
          usersKeys.map(async userId => {
            if (!!userId === false) return false
            const user = await getUserByID(userId)
            if (!!user === false) return false
            user.shortName = this.fixedName(user.nome)
            return user
          })
        )).filter(user => !!user)
        this.users = users
        this.$emit('setButtonState', false)
        this.loading = false
        this.reportStatus = 'loaded'
        if (this.duties.length === 0) {
          this.showMessage('Atenção!', `Não há plantões em ${this.months[this.month]} de ${this.year}`)
        }
        const { getAvailablesRow, getUserRows, getTotalsRow } = this
        const availableRow = getAvailablesRow()
        const allUserRows = getUserRows()
        const usersWithShifts = allUserRows.filter(user => user.qtd > 0)
        const usersWithZeroShifts = allUserRows.filter(user => user.qtd === 0)
        this.tableData = [availableRow, ...usersWithShifts]
        const totalRow = getTotalsRow()
        this.tableData = [
          availableRow,
          ...usersWithShifts,
          totalRow,
          ...usersWithZeroShifts,
        ]
      },

      getDataFromDuties (duties = [], name = '', options = this.options) {
        let qtd = 0
        let total = 0
        const days = []

        duties.forEach((duty) => {
          qtd++
          const dateMoment = (duty.dutyStartDateTZ || '') === '+0000' ? moment.utc(duty.data_inicio) : moment(duty.data_inicio)
          const day = parseInt(dateMoment.format('D'))


          let startHour = 0;
          if (duty.hora_inicio && typeof duty.hora_inicio === 'string') {
            startHour = parseInt(duty.hora_inicio.split(':')[0], 10);
          } else {
            startHour = parseInt(dateMoment.format('H'), 10);
          }

          //console.log(startHour)
          const isNightShift = startHour >= 17

          const dutyDurationFormat = valueToTime(duty.periodo, true)
          const dutyDuration = timestrToSec(dutyDurationFormat)

          const dutyDetail = {
            start: duty.hora_inicio || dateMoment.format('HH:mm'),
            duration: dutyDurationFormat,
            value: duty.valor || 0,
            isNight: isNightShift,
            scale: duty.scaleName || duty.nome || 'Sem escala',
          }

          if (days[day]) {
            days[day].durationInSeconds += dutyDuration
            days[day].durationHourAndMinutes = days[day].durationInSeconds > 0 ? formatSecondsToTime(days[day].durationInSeconds) : ''
            days[day].formattedDurationHourAndMinutes = days[day].durationInSeconds > 0 ? formatDurationForTable(days[day].durationHourAndMinutes) : ''
            days[day].dutiesList.push(dutyDetail)

            if (isNightShift) {
              days[day].hasNightShift = true;
            } else {
              days[day].hasDayShift = true;
            }
          } else {
            const dutyDurationSecondsToTime = formatSecondsToTime(dutyDuration)
            days[day] = {
              durationInSeconds: dutyDuration,
              durationHourAndMinutes: dutyDuration > 0 ? dutyDurationSecondsToTime : '',
              formattedDurationHourAndMinutes: dutyDuration > 0 ? formatDurationForTable(dutyDurationSecondsToTime) : '',
              highlight: false,
              hasDayShift: !isNightShift,
              hasNightShift: isNightShift,
              dutiesList: [dutyDetail]
            }
          }
          total += dutyDuration
        })
        return { name, qtd, ...days, total, totalNumerico: 0, ...options }
      },

      getAvailablesRow () {
        const { availableDutyFilter, getDataFromDuties } = this
        const duties = this.duties.filter((duty) => availableDutyFilter(duty))
        const data = getDataFromDuties(duties, 'Disponíveis')
        data.totalNumerico = data.total
        data.total = formatDuration(formatSecondsToTime(data.total, false), true)
        return data
      },
      getUserRow (user) {
        const { userDutyFilter } = this
        const duties = this.duties.filter((duty) => userDutyFilter(duty, user))
        const data = this.getDataFromDuties(duties, user.shortName)
        data.totalNumerico = data.total
        data.total = formatDuration(formatSecondsToTime(data.total, false), true)
        return data
      },

      getUserRows () {
        const { users, getUserRow } = this
        let trataUsuarios = users.map((user) => getUserRow(user))
        trataUsuarios.sort((a, b) => b.qtd - a.qtd)
        return trataUsuarios
      },

      getTotalsRow () {
        const { tableData, daysInMonth, options } = this
        const tableTotal = tableData.reduce((a, b) => a + parseInt(b.totalNumerico || 0), 0)
        const tableTotalNumerico = tableData.length > 0 ? tableData[0].totalNumerico : 0
        const totalSemDisponiveis = tableTotal > tableTotalNumerico ? tableTotal - tableTotalNumerico : tableTotalNumerico - tableTotal
        var total = {
          name: 'Total',
          qtd: tableData.reduce((a, b) => a + parseInt(b.qtd || 0), 0) - (tableData.length > 0 ? tableData[0].qtd : 0),
          total: formatDuration(formatSecondsToTime(totalSemDisponiveis, false), true),
          totalNumerico: tableTotal,
          ...options,
        }
        const apenasUsuarios = tableData.slice(1, tableData.length)
        daysInMonth.forEach(({ value: day }) => {
          const existeEmDisponiveis = tableData.length > 0 && tableData[0][day] ? tableData[0][day].durationInSeconds : 0
          const somaTodos = tableData.reduce((a, b) => a + (b[day] ? parseInt(b[day].durationInSeconds) : 0), 0)
          const somaApenasUsuarios = apenasUsuarios.reduce((a, b) => a + (b[day] ? parseInt(b[day].durationInSeconds) : 0), 0)
          const daySum = existeEmDisponiveis > 0 ? (somaTodos - existeEmDisponiveis) : somaTodos
          const daySumFormatted = formatSecondsToTime(daySum, false)
          total[day] = {
            durationInSeconds: daySum,
            durationHourAndMinutes: daySum > 0 ? daySumFormatted : '',
            formattedDurationHourAndMinutes: daySum > 0 ? formatDurationForTable(daySumFormatted) : '',
            highlight: somaApenasUsuarios > 0 && existeEmDisponiveis > 0,
            dutiesList: []
          }
        })
        return total
      },
    },
  }
</script>

<style lang="scss" scoped>

  .clickable-cell {
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .legend-container {
    display: flex;
    gap: 16px;
    margin-left: 16px;
    align-items: center;
    font-size: 13px;
    padding-top: 25px;
    flex-wrap: wrap;
  }
  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .legend-color-box {
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .legend-color-box--day {
    background-color: #ffc609;
  }
  .legend-color-box--night {
    background-color: #42426E;
  }
  .legend-color-box--split {
    background: linear-gradient(to right, #ffc609 50%, #42426E 50%);
  }

  .bgTotal {
    background-color: rgba(255, 255, 0, 0.1);
    td {
      span {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .timeReportDialogBody {
    padding: 0;
    overflow-y: scroll;
    // max-height
    font-size: 16px;
    &::-webkit-scrollbar {
      width: 15px !important;
    }
  }

  .relatorio-tables {
    display: inline-block;
    width: 100%;
    padding-top: 20px;
  }

  .rel-table-users {
    float: left;
    width: 14.487%;
  }

  .rel-table-calendar {
    float: left;
    display: block;
    width: 79.349%;
  }

  .rel-table-totalhoras {
    float: left;
    width: 6.164%;
  }

  @media (max-width: 1680px) {
    .relatorio-tables {
      width: 1680px;
    }
  }

  .rel-table-calendar table {
    width: 100%;
  }

  .rel-table-users th,
  .rel-table-calendar th,
  .rel-table-totalhoras th {
    font-size: 14px;
  }

  .rel-table-users td,
  .rel-table-calendar td,
  .rel-table-totalhoras td {
    font-size: 15px;
    line-height: 22px;
  }

  .rel-table-users-th-top-cl1,
  .rel-table-users-th-top-cl2 {
    padding-top: 0;
    padding-bottom: 0;
    font-weight: 300;
    color: #ffffff;
  }

  .rel-table-users-th-bottom-cl1 {
    padding-left: 10px;
    padding-top: 0;
    padding-bottom: 7px;
  }
  .rel-table-users-th-bottom-cl2 {
    padding-top: 0;
    padding-bottom: 7px;
    text-align: center !important;
  }

  .rel-table-totalhoras td,
  .rel-table-users td,
  .rel-table-users-th-bottom-cl1,
  .rel-table-users-th-bottom-cl2 {
    border-bottom: 1px solid #cecece;
  }

  .rel-table-users-cl2-first,
  .rel-table-users-cl2 {
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: center !important;
  }

  .rel-table-users-cl1 span {
    display: inline-block;
    padding-left: 10px;
    color: rgba(0, 0, 0, 0.87);
    font-size: 13px;
    font-weight: bold;
  }

  abbr[title] {
    border-bottom: none !important;
    cursor: default !important;
  }

  .rel-table-totalhoras td,
  .rel-table-totalhoras th,
  .rel-table-users td,
  .rel-table-users th {
    text-align: left;
  }

  .rel-table-calendar table td.highlight {
    background-color: #3cb371;
    box-shadow: inset 2px 1px 7px 0px #228b22;
    border-left-color: #228b22;
    border-bottom-color: #228b22;
    color: #ffffff;
  }
  .rel-table-calendar table .highlight_red {
    color: #ff0000;
    font-weight: 600;
  }

  .rel-table-calendar table td.day-shift {
    background-color: #ffc609;
    color: #000;
  }

  .rel-table-calendar table td.night-shift {
    background-color: #42426E;
    color: #ffffff;
  }

  .rel-table-calendar table td.split-shift {
    background: linear-gradient(to right, #ffc609 50%, #42426E 50%);
    color: #ffffff;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  }

  .rel-table-calendar table td,
  .rel-table-totalhoras td {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .rel-table-totalhoras-th-top {
    padding-top: 0;
    padding-bottom: 0;
    font-weight: 300;
    span {
      color: #ffffff;
    }
  }

  th.rel-table-totalhoras-th-bottom {
    padding-top: 0;
    padding-bottom: 7px;
    border-bottom: 1px solid #cecece;
  }

  .rel-table-totalhoras th span,
  .rel-table-totalhoras td span {
    display: inline-block;
    padding-left: 10px;
  }

  .rel-table-calendar table td,
  .rel-table-calendar table th {
    text-align: center;
  }
  .rel-table-calendar table th {
    min-width: 32px;
    width: 2.34374986vw;
  }

  .rel-table-calendar-th-top {
    padding-top: 0;
    padding-bottom: 0;
    font-weight: 300;
  }

  .rel-table-calendar-th-bottom {
    padding-top: 0;
    padding-bottom: 7px;
    border-bottom: 1px solid #cecece;
  }

  .rel-table-calendar table th {
    border-left: 1px solid transparent;
    &.last {
      border-right: 1px solid transparent;
    }
  }

  .rel-table-calendar table td {
    border-bottom: 1px solid #cecece;
    border-left: 1px solid #efefef;
    &.last {
      border-right: 1px solid #efefef;
    }
  }

  .qnt_disponiveis,
  .qnt_usuario {
    display: inline-block;
    width: 34px;
    height: 34px;
    padding-left: 0;
    border-radius: 50%;
    line-height: 34px;
  }

  .qnt_disponiveis {
    background-color: #3cb371;
    box-shadow: inset 2px 1px 7px 0px #228b22;
    color: #ffffff;
  }
</style>
